export const ALL_SAVE_MORE_DEBITS = "ALL_SAVE_MORE_DEBITS"
export const ALL_SAVE_MORE_DEBITS_FAIL = "ALL_SAVE_MORE_DEBITS_FAIL"
export const ALL_SAVE_MORE_DEBITS_SUCCESS = "ALL_SAVE_MORE_DEBITS_SUCCESS"
export const APPROVE_PAYMENT = "APPROVE_PAYMENT"
export const APPROVE_PAYMENT_FAIL = "APPROVE_PAYMENT_FAIL"
export const APPROVE_PAYMENT_SUCCESS = "APPROVE_PAYMENT_SUCCESS"
export const CAN_CANCEL = "CAN_CANCEL"
export const CAN_CANCEL_FAIL = "CAN_CANCEL_FAIL"
export const CAN_CANCEL_SUCCESS = "CAN_CANCEL_SUCCESS"
export const CANCELLATION = "CANCELLATION"
export const CANCELLATION_FAIL = "CANCELLATION_FAIL"
export const CANCELLATION_SUCCESS = "CANCELLATION_SUCCESS"
export const CHANGE_CUSTOMER = "CHANGE_CUSTOMER"
export const CHANGE_EXPIRATION_DATE = "CHANGE_EXPIRATION_DATE"
export const CHANGE_EXPIRATION_DATE_FAIL = "CHANGE_EXPIRATION_DATE_FAIL"
export const CHANGE_EXPIRATION_DATE_SUCCESS = "CHANGE_EXPIRATION_DATE_SUCCESS"
export const CHANGE_LOADER = "CHANGE_LOADER"
export const CLEAR_ADDRESS_SELECTEDS = "CLEAR_ADDRESS_SELECTEDS"
export const CLEAR_ADDRESS_ZIPCODE = "CLEAR_ADDRESS_ZIPCODE"
export const CLOSE_MODAL = "CLOSE_MODAL"
export const CLOSE_EMIT_FAIL_MODAL = "CLOSE_EMIT_FAIL_MODAL"
export const CREATE_CONTACT = "CREATE_CONTACT"
export const CREATE_CONTACT_FAIL = "CREATE_CONTACT_FAIL"
export const CREATE_CONTACT_SUCCESS = "CREATE_CONTACT_SUCCESS"
export const CREATE_INCIDENT_ORDER = "CREATE_INCIDENT_ORDER"
export const CREATE_INCIDENT_ORDER_FAIL = "CREATE_INCIDENT_ORDER_FAIL"
export const CREATE_INCIDENT_ORDER_SUCCESS = "CREATE_INCIDENT_ORDER_SUCCESS"
export const CREATE_ODIN_INCIDENT_ORDER = "CREATE_ODIN_INCIDENT_ORDER"
export const CREATE_ODIN_INCIDENT_ORDER_FAIL = "CREATE_ODIN_INCIDENT_ORDER_FAIL"
export const CREATE_ODIN_INCIDENT_ORDER_SUCCESS =
  "CREATE_ODIN_INCIDENT_ORDER_SUCCESS"
export const CREATE_SERVICE_ORDER = "CREATE_SERVICE_ORDER"
export const CREATE_SERVICE_REQUEST = "CREATE_SERVICE_REQUEST"
export const CREATE_USER = "CREATE_USER"
export const CREATE_USER_FAIL = "CREATE_USER_FAIL"
export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS"
export const DOWNLOAD_FEBRABAN_ACCOUNT = "DOWNLOAD_FEBRABAN_ACCOUNT"
export const DOWNLOAD_INVOICE = "DOWNLOAD_INVOICE"
export const DOWNLOAD_INVOICE_FAIL = "DOWNLOAD_INVOICE_FAIL"
export const DOWNLOAD_INVOICE_LOADER = "DOWNLOAD_INVOICE_LOADER"
export const DOWNLOAD_INVOICE_SUCCESS = "DOWNLOAD_INVOICE_SUCCESS"
export const DOWNLOAD_MULTIPLE_INVOICES_FAIL = "DOWNLOAD_MULTIPLE_INVOICES_FAIL"
export const DOWNLOAD_MULTIPLE_INVOICES_SUCCESS =
  "DOWNLOAD_MULTIPLE_INVOICES_SUCCESS"
export const DOWNLOAD_MULTIPLE_INVOICES = "DOWNLOAD_MULTIPLE_INVOICES"
export const DOWNLOAD_MULTIPLE_INVOICES_RESET =
  "DOWNLOAD_MULTIPLE_INVOICES_RESET"

export const DOWNLOAD_PRODUCTS_PLANT = "DOWNLOAD_PRODUCTS_PLANT"
export const DOWNLOAD_REQUEST_DETAIL = "DOWNLOAD_REQUEST_DETAIL"
export const DOWNLOAD_REQUEST_DETAIL_FAIL = "DOWNLOAD_REQUEST_DETAIL_FAIL"
export const DOWNLOAD_REQUEST_DETAIL_SUCCESS = "DOWNLOAD_REQUEST_DETAIL_SUCCESS"
export const DOWNLOAD_TRAFFIC_DETAILS = "DOWNLOAD_TRAFFIC_DETAILS"
export const DOWNLOAD_TRAFFIC_DETAILS_FAIL = "DOWNLOAD_TRAFFIC_DETAILS_FAIL"
export const DOWNLOAD_TRAFFIC_DETAILS_SUCCESS =
  "DOWNLOAD_TRAFFIC_DETAILS_SUCCESS"
export const EMIT_BILLET = "EMIT_BILLET"
export const EMIT_BILLET_SUCCESS = "EMIT_BILLET_SUCCESS"
export const EMIT_BILLET_FAIL = "EMIT_BILLET_FAIL"
export const ERROR_CALC = "ERROR_CALC"
export const FILTER_CLOSED_INVOICES = "FILTER_CLOSED_INVOICES"
export const FILTER_DUE_INVOICES = "FILTER_DUE_INVOICES"
export const FILTER_NEGOTIATION_LOGS = "FILTER_NEGOTIATION_LOGS"
export const FILTER_NEGOTIATION_LOGS_FAIL = "FILTER_NEGOTIATION_LOGS_FAIL"
export const FILTER_NEGOTIATION_LOGS_SUCCESS = "FILTER_NEGOTIATION_LOGS_SUCCESS"
export const FILTER_NEXT_INVOICES = "FILTER_NEXT_INVOICES"
export const FILTER_OPEN_INVOICES = "FILTER_OPEN_INVOICES"
export const FILTER_OPEN_INVOICES_SUCCESS = "FILTER_OPEN_INVOICES_SUCCESS"
export const FILTER_CLOSED_INVOICES_SUCCESS = "FILTER_CLOSED_INVOICES_SUCCESS"
export const FILTER_DUE_INVOICES_SUCCESS = "FILTER_DUE_INVOICES_SUCCESS"
export const FILTER_NEXT_INVOICES_SUCCESS = "FILTER_NEXT_INVOICES_SUCCESS"
export const GET_ADDRESS = "GET_ADDRESS"
export const GET_ADDRESS_BY_ZIPCODE = "GET_ADDRESS_BY_ZIPCODE"
export const GET_ADDRESS_SUCCESS = "GET_ADDRESS_SUCCESS"
export const GET_ADDRESS_FAIL = "GET_ADDRESS_FAIL"
export const GET_BANK_DATA = "GET_BANK_DATA"
export const GET_BANK_DATA_ERROR = "GET_BANK_DATA_ERROR"
export const GET_BANK_DATA_FAIL = "GET_BANK_DATA_FAIL"
export const GET_BANK_DATA_SUCCESS = "GET_BANK_DATA_SUCCESS"
export const GET_BANKS = "GET_BANKS"
export const GET_BANKS_FAIL = "GET_BANKS_FAIL"
export const GET_BANKS_SUCCESS = "GET_BANKS_SUCCESS"
export const GET_BILLS = "GET_BILLS"
export const GET_ACCOUNT_ALIAS_NAME = "GET_ACCOUNT_ALIAS_NAME"
export const GET_ACCOUNT_ALIAS_NAME_SUCCESS = "GET_ACCOUNT_ALIAS_NAME_SUCCESS"
export const GET_ACCOUNT_ALIAS_NAME_FAIL = "GET_ACCOUNT_ALIAS_NAME_FAIL"
export const SET_ACCOUNT_ALIAS_NAME = "SET_ACCOUNT_ALIAS_NAME"
export const SET_ACCOUNT_ALIAS_NAME_SUCCESS = "SET_ACCOUNT_ALIAS_NAME_SUCCESS"
export const SET_ACCOUNT_ALIAS_NAME_CLOSE_SUCCESS =
  "SET_ACCOUNT_ALIAS_NAME_CLOSE_SUCCESS"
export const SET_ACCOUNT_ALIAS_NAME_FAIL = "SET_ACCOUNT_ALIAS_NAME_FAIL"
export const DELETE_ACCOUNT_ALIAS_NAME = "DELETE_ACCOUNT_ALIAS_NAME"
export const DELETE_ACCOUNT_ALIAS_NAME_SUCCESS =
  "DELETE_ACCOUNT_ALIAS_NAME_SUCCESS"
export const DELETE_ACCOUNT_ALIAS_NAME_FAIL = "DELETE_ACCOUNT_ALIAS_NAME_FAIL"
export const GET_BILLS_FAIL = "GET_BILLS_FAIL"
export const GET_BILLS_SUCCESS = "GET_BILLS_SUCCESS"
export const GET_CALC = "GET_CALC"
export const GET_CALC_FAIL = "GET_CALC_FAIL"
export const GET_CALCULATE_NUMBER_PLOTS = "GET_CALCULATE_NUMBER_PLOTS"
export const GET_CALCULATE_NUMBER_PLOTS_SUCCESS =
  "GET_CALCULATE_NUMBER_PLOTS_SUCCESS"
export const GET_CONTACT = "GET_CONTACT"
export const GET_PERMISSIONS = "GET_PERMISSIONS"
export const GET_PERMISSIONS_SUCCESS = "GET_PERMISSIONS_SUCCESS"
export const GET_PERMISSIONS_FAIL = "GET_PERMISSIONS_FAIL"
export const GET_CUSTOMER = "GET_CUSTOMER"
export const GET_CUSTOMER_FAIL = "GET_CUSTOMER_FAIL"
export const GET_CUSTOMER_SUCCESS = "GET_CUSTOMER_SUCCESS"
export const GET_FEBRABAN_ACCOUNTS = "GET_FEBRABAN_ACCOUNTS"
export const GET_FEBRABAN_ACCOUNTS_SUCCESS = "GET_FEBRABAN_ACCOUNTS_SUCCESS"
export const GET_INCIDENT_PRODUCT_DETAIL = "GET_INCIDENT_PRODUCT_DETAIL"
export const GET_INCIDENT_PRODUCT_DETAIL_SUCCESS =
  "GET_INCIDENT_PRODUCT_DETAIL_SUCCESS"
export const GET_INSTALLMENTS = "GET_INSTALLMENTS"
export const GET_INSTALLMENTS_SUCCESS = "GET_INSTALLMENTS_SUCCESS"
export const GET_INVOICE_NEGOTIATION = "GET_INVOICE_NEGOTIATION"
export const GET_INVOICE_NEGOTIATION_SUCCESS = "GET_INVOICE_NEGOTIATION_SUCCESS"
export const GET_INVOICES = "GET_INVOICES"
export const GET_ALL_INVOICES = "GET_ALL_INVOICES"
export const GET_ALL_INVOICES_FAIL = "GET_ALL_INVOICES_FAIL"
export const GET_ALL_INVOICES_SUCCESS = "GET_ALL_INVOICES_SUCCESS"
export const GET_INVOICES_FAIL = "GET_INVOICES_FAIL"
export const GET_INVOICES_SUCCESS = "GET_INVOICES_SUCCESS"
export const SET_INVOICES_SELECTED_NEGOTIATION =
  "SET_INVOICES_SELECTED_NEGOTIATION"
export const GET_NEGOTIATION_LOGS = "GET_NEGOTIATION_LOGS"
export const GET_NEGOTIATION_LOGS_FAIL = "GET_NEGOTIATION_LOGS_FAIL"
export const GET_NEGOTIATION_LOGS_SUCCESS = "GET_NEGOTIATION_LOGS_SUCCESS"
export const GET_PRODUCT_DETAIL = "GET_PRODUCT_DETAIL"
export const GET_PRODUCT_DETAIL_FAIL = "GET_PRODUCT_DETAIL_FAIL"
export const GET_PRODUCT_DETAIL_SUCCESS = "GET_PRODUCT_DETAIL_SUCCESS"
export const GET_PRODUCTS = "GET_PRODUCTS"
export const GET_PRODUCTS_FAIL = "GET_PRODUCTS_FAIL"
export const GET_PRODUCTS_PLANT = "GET_PRODUCTS_PLANT"
export const GET_PRODUCTS_PLANT_FAIL = "GET_PRODUCTS_PLANT_FAIL"
export const GET_PRODUCTS_PLANT_SUCCESS = "GET_PRODUCTS_PLANT_SUCCESS"
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS"
export const GET_REPAIR = "GET_REPAIR"
export const GET_REPAIR_BY_PROTOCOL = "GET_REPAIR_BY_PROTOCOL"
export const GET_REPAIR_BY_PROTOCOL_FAIL = "GET_REPAIR_BY_PROTOCOL_FAIL"
export const GET_REPAIR_BY_PROTOCOL_SUCCESS = "GET_REPAIR_BY_PROTOCOL_SUCCESS"
export const GET_REPAIR_FAIL = "GET_REPAIR_FAIL"
export const GET_REPAIR_SUCCESS = "GET_REPAIR_SUCCESS"
export const GET_RESULT_CALC = "GET_RESULT_CALC"
export const GET_RESULT_CALC_FAIL = "GET_RESULT_CALC_FAIL"
export const GET_RESULT_CALC_SUCCESS = "GET_RESULT_CALC_SUCCESS"
export const GET_SERVICE_ORDER = "GET_SERVICE_ORDER"
export const GET_SERVICE_ORDER_FAIL = "GET_SERVICE_ORDER_FAIL"
export const GET_SERVICE_ORDER_SUCCESS = "GET_SERVICE_ORDER_SUCCESS"
export const GET_STATUS_CALC = "GET_STATUS_CALC"
export const GET_STATUS_CALC_FAIL = "GET_STATUS_CALC_FAIL"
export const GET_STATUS_CALC_SUCCESS = "GET_STATUS_CALC_SUCCESS"
export const GET_TRAFFIC_DETAILS = "GET_TRAFFIC_DETAILS"
export const GET_TRAFFIC_DETAILS_FAIL = "GET_TRAFFIC_DETAILS_FAIL"
export const GET_TRAFFIC_DETAILS_SUCCESS = "GET_TRAFFIC_DETAILS_SUCCESS"
export const GET_TRAFFIC_SUMMARY = "GET_TRAFFIC_SUMMARY"
export const GET_TRAFFIC_SUMMARY_FAIL = "GET_TRAFFIC_SUMMARY_FAIL"
export const GET_TRAFFIC_SUMMARY_SUCCESS = "GET_TRAFFIC_SUMMARY_SUCCESS"
export const GET_PORTABILITY_INFORMATION = "GET_PORTABILITY_INFORMATIONY"
export const GET_PORTABILITY_INFORMATION_FAIL =
  "GET_PORTABILITY_INFORMATION_FAIL"
export const GET_PORTABILITY_INFORMATION_SUCCESS =
  "GET_PORTABILITY_INFORMATION_SUCCESS"
export const GET_TYPE_COMPLEMENT = "GET_TYPE_COMPLEMENT"
export const GET_TYPE_COMPLEMENT_SUCCESS = "GET_TYPE_COMPLEMENT_SUCCESS"
export const GET_URL_PAYMENT = "GET_URL_PAYMENT"
export const GET_URL_PAYMENT_SUCCESS = "GET_URL_PAYMENT_SUCCESS"
export const INFORMATION_RETURN = "INFORMATION_RETURN"
export const PORTABILITY_INFORMATION_RETURN = "PORTABILITY_INFORMATION_RETURN"
export const INVOICE_ASYNC_DOWNLOAD_NOTIFICATION =
  "INVOICE_ASYNC_DOWNLOAD_NOTIFICATION"
export const INVOICE_ASYNC_DOWNLOAD_NOTIFICATION_DISMISS =
  "INVOICE_ASYNC_DOWNLOAD_NOTIFICATION_DISMISS"
export const ISSUE_ORDER = "ISSUE_ORDER"
export const LOGIN = "LOGIN"
export const LOGIN_FAIL = "LOGIN_FAIL"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const LOGOUT = "LOGOUT"
export const MONTHS_DETAILING = "MONTHS_DETAILING"
export const MONTHS_DETAILING_DOWNLOAD = "MONTHS_DETAILING_DOWNLOAD"
export const MONTHS_DETAILING_DOWNLOAD_FAIL = "MONTHS_DETAILING_DOWNLOAD_FAIL"
export const MONTHS_DETAILING_DOWNLOAD_SUCCESS =
  "MONTHS_DETAILING_DOWNLOAD_SUCCESS"
export const MONTHS_DETAILING_EMAILS = "MONTHS_DETAILING_EMAILS"
export const MONTHS_DETAILING_EMAILS_SUCCESS = "MONTHS_DETAILING_EMAILS_SUCCESS"
export const MONTHS_DETAILING_EMAILS_FAIL = "MONTHS_DETAILING_EMAILS_FAIL"
export const MONTHS_DETAILING_SUCCESS = "MONTHS_DETAILING_SUCCESS"
export const MONTHS_LOADER = "MONTHS_LOADER"
export const OPEN_MODAL = "OPEN_MODAL"
export const POSSIBLE_EXPIRATION_DATES = "POSSIBLE_EXPIRATION_DATES"
export const POSSIBLE_EXPIRATION_DATES_FAIL = "POSSIBLE_EXPIRATION_DATES_FAIL"
export const POSSIBLE_EXPIRATION_DATES_SUCCESS =
  "POSSIBLE_EXPIRATION_DATES_SUCCESS"
export const QUERY_OPEN_REASON = "QUERY_OPEN_REASON"
export const QUERY_OPEN_REASON_FAIL = "QUERY_OPEN_REASON_FAIL"
export const QUERY_OPEN_REASON_SUCCESS = "QUERY_OPEN_REASON_SUCCESS"
export const REMOVE_CONTACT = "REMOVE_CONTACT"
export const REMOVE_CONTACT_FAIL = "REMOVE_CONTACT_FAIL"
export const REMOVE_CONTACT_SUCCESS = "REMOVE_CONTACT_SUCCESS"
export const REQUEST_DEBIT = "REQUEST_DEBIT"
export const RESTORE_CREDENTIALS = "RESTORE_CREDENTIALS"
export const SAVE_CARD_DATA = "SAVE_CARD_DATA"
export const SAVE_DEBIT = "SAVE_DEBIT"
export const SAVE_DEBIT_FAIL = "SAVE_DEBIT_FAIL"
export const SAVE_DEBIT_SUCCESS = "SAVE_DEBIT_SUCCESS"
export const DELETE_DEBIT = "DELETE_DEBIT"
export const DELETE_DEBIT_FAIL = "DELETE_DEBIT_FAIL"
export const DELETE_DEBIT_SUCCESS = "DELETE_DEBIT_SUCCESS"
export const SELECT_BILL = "SELECT_BILL"
export const SELECT_INCIDENT_PRODUCT = "SELECT_INCIDENT_PRODUCT"
export const SELECT_INCIDENT_REASON = "SELECT_INCIDENT_REASON"
export const SELECT_PRODUCT = "SELECT_PRODUCT"
export const SELECT_TRAFFIC_SUCCESS = "SELECT_TRAFFIC_SUCCESS"
export const GET_INVOICE_PIX = "GET_INVOICE_PIX"
export const GET_INVOICE_PIX_SUCCESS = "GET_INVOICE_PIX_SUCCESS"
export const GET_INVOICE_PIX_ERROR = "GET_INVOICE_PIX_ERROR"
export const SEND_INVOICE_BY_EMAIL = "SEND_INVOICE_BY_EMAIL"
export const SEND_INVOICE_BY_EMAIL_FAIL = "SEND_INVOICE_BY_EMAIL_FAIL"
export const SEND_INVOICE_BY_EMAIL_SUCCESS = "SEND_INVOICE_BY_EMAIL_SUCCESS"
export const SEND_MAIL = "SEND_MAIL"
export const SEND_MAIL_FAIL = "SEND_MAIL_FAIL"
export const SEND_MAIL_REQUEST_DETAIL = "SEND_MAIL_REQUEST_DETAIL"
export const SEND_MAIL_REQUEST_DETAIL_FAIL = "SEND_MAIL_REQUEST_DETAIL_FAIL"
export const SEND_MAIL_REQUEST_DETAIL_SUCCESS =
  "SEND_MAIL_REQUEST_DETAIL_SUCCESS"
export const SEND_MAIL_SUCCESS = "SEND_MAIL_SUCCESS"
export const SEND_PRODUCTS_PLANT_BY_EMAIL = "SEND_PRODUCTS_PLANT_BY_EMAIL"
export const SEND_PRODUCTS_PLANT_BY_EMAIL_DISMISS =
  "PRODUCTS_PLANT_ASYNC_DOWNLOAD_NOTIFICATION_DISMISS"
export const SEND_PRODUCTS_PLANT_BY_EMAIL_FAIL =
  "SEND_PRODUCTS_PLANT_BY_EMAIL_FAIL"
export const SEND_PRODUCTS_PLANT_BY_EMAIL_SUCCESS =
  "SEND_PRODUCTS_PLANT_BY_EMAIL_SUCCESS"
export const SEND_TRAFFIC_EMAIL = "SEND_TRAFFIC_EMAIL"
export const SEND_TRAFFIC_EMAIL_FAIL = "SEND_TRAFFIC_EMAIL_FAIL"
export const SEND_TRAFFIC_EMAIL_SUCCESS = "SEND_TRAFFIC_EMAIL_SUCCESS"
export const SEND_USER_ACTIVATION_EMAIL = "SEND_USER_ACTIVATION_EMAIL"
export const SEND_USER_ACTIVATION_EMAIL_FAIL = "SEND_USER_ACTIVATION_EMAIL_FAIL"
export const SEND_USER_ACTIVATION_EMAIL_SUCCESS =
  "SEND_USER_ACTIVATION_EMAIL_SUCCESS"
export const SENDMAIL = "SENDMAIL"
export const SENDMAIL_SUCCESS = "SENDMAIL_SUCCESS"
export const SET_ADDRESS_BY_ZIPCODE = "SET_ADDRESS_BY_ZIPCODE"
export const SET_DEBIT = "SET_DEBIT"
export const SET_ERROR_DOWNLOAD = "SET_ERROR_DOWNLOAD"
export const SET_LAST_CUSTOMER_UPDATE = "SET_LAST_CUSTOMER_UPDATE"
export const SET_LAST_EMAIL_UPDATE = "SET_LAST_EMAIL_UPDATE"
export const SET_MODAL = "SET_MODAL"
export const SET_MODAL_CUSTOMER = "SET_MODAL_CUSTOMER"
export const SEND_RESCHEDULING = "SEND_RESCHEDULING"
export const SEND_RESCHEDULING_SUCCESS = "SEND_RESCHEDULING_SUCCESS"
export const SEND_RESCHEDULING_FAIL = "SEND_RESCHEDULING_FAIL"
export const UPDATE_EMAIL = "UPDATE_EMAIL"
export const SET_PARCELING = "SET_PARCELING"
export const SET_PARCELING_DATA = "SET_PARCELING_DATA"
export const UPDATE_ADDRESS = "UPDATE_ADDRESS"
export const UPDATE_ADDRESS_FAIL = "UPDATE_ADDRESS_FAIL"
export const UPDATE_ADDRESS_LOCALITY = "UPDATE_ADDRESS_LOCALITY"
export const UPDATE_ADDRESS_STREET = "UPDATE_ADDRESS_STREET"
export const UPDATE_ADDRESS_SUCCESS = "UPDATE_ADDRESS_SUCCESS"
export const UPDATE_BILL = "UPDATE_BILL"
export const UPDATE_BILL_FAIL = "UPDATE_BILL_FAIL"
export const UPDATE_BILL_SUCCESS = "UPDATE_BILL_SUCCESS"
export const UPDATE_CONTACT = "UPDATE_CONTACT"
export const UPDATE_CONTACT_FAIL = "UPDATE_CONTACT_FAIL"
export const UPDATE_CONTACT_SUCCESS = "UPDATE_CONTACT_SUCCESS"
export const UPDATE_CUSTOMER = "UPDATE_CUSTOMER"
export const VALIDATE_CUSTOMER_PASSWORD = "VALIDATE_CUSTOMER_PASSWORD"
export const CHANGE_CUSTOMER_PASSWORD = "CHANGE_CUSTOMER_PASSWORD"
export const VALIDATE_CUSTOMER_PASSWORD_SUCCESS =
  "VALIDATE_CUSTOMER_PASSWORD_SUCCESS"
export const VALIDATE_CUSTOMER_PASSWORD_FAIL = "VALIDATE_CUSTOMER_PASSWORD_FAIL"
export const CHANGE_CUSTOMER_PASSWORD_SUCCESS =
  "CHANGE_CUSTOMER_PASSWORD_SUCCESS"
export const CHANGE_CUSTOMER_PASSWORD_FAIL = "CHANGE_CUSTOMER_PASSWORD_FAIL"
export const UPDATE_CUSTOMER_FAIL = "UPDATE_CUSTOMER_FAIL"
export const UPDATE_CUSTOMER_SUCCESS = "UPDATE_CUSTOMER_SUCCESS"
export const UPDATE_PRODUCTS_DETAILS = "UPDATE_PRODUCTS_DETAILS"
export const UPDATE_PRODUCTS_DETAILS_FAIL = "UPDATE_PRODUCTS_DETAILS_FAIL"
export const UPDATE_PRODUCTS_DETAILS_SUCCESS = "UPDATE_PRODUCTS_DETAILS_SUCCESS"
export const SEND_INCIDENT_REQUEST = "SEND_INCIDENT_REQUEST"
export const SEND_INCIDENT_REQUEST_SUCCESS = "SEND_INCIDENT_REQUEST_SUCCESS"
export const SEND_INCIDENT_REQUEST_FAIL = "SEND_INCIDENT_REQUEST_FAIL"
export const CHANGE_SOLICITATION_STATUS = "CHANGE_SOLICITATION_STATUS"
export const CHANGE_SOLICITATION_STATUS_SUCCESS =
  "CHANGE_SOLICITATION_STATUS_SUCCESS"
export const CHANGE_SOLICITATION_STATUS_FAIL = "CHANGE_SOLICITATION_STATUS_FAIL"
export const CLEAN_WIZARD = "CLEAN_WIZARD"
export const RECHARGE_REQUEST = "RECHARGE_REQUEST"
export const RECHARGE_REQUEST_SUCCESS = "RECHARGE_REQUEST_SUCCESS"
export const RECHARGE_REQUEST_FAIL = "RECHARGE_REQUEST_ERROR"
export const CHECK_CREDIT_CARD = "CHECK_CREDIT_CARD"
export const CHECK_CREDIT_CARD_SUCCESS = "CHECK_CREDIT_CARD_SUCCESS"
export const CHECK_CREDIT_CARD_FAIL = "CHECK_CREDIT_CARD_FAIL"
export const CHECK_PHONE_NUMBER = "CHECK_PHONE_NUMBER"
export const CHECK_PHONE_NUMBER_SUCCESS = "CHECK_PHONE_NUMBER_SUCCESS"
export const CHECK_PHONE_NUMBER_FAIL = "CHECK_PHONE_NUMBER_FAIL"
export const ORDER_NEGOTIATION_LOGS = "ORDER_NEGOTIATION_LOGS"
export const FOLLOW_TECHNICIAN_MODAL_STATE = "FOLLOW_TECHNICIAN_MODAL_STATE"
export const SENSEDIA_GRANT_CODE = "SENSEDIA_GRANT_CODE"
export const SENSEDIA_ACCESS_CODE = "SENSEDIA_ACCESS_CODE"
export const SENSEDIA_REPEAT_REQUEST = "SENSEDIA_REPEAT_REQUEST"
export const SENSEDIA_CORP_GRANT_CODE = "SENSEDIA_CORP_GRANT_CODE"
export const SENSEDIA_CORP_ACCESS_CODE = "SENSEDIA_CORP_ACCESS_CODE"
export const SENSEDIA_CORP_REPEAT_REQUEST = "SENSEDIA_CORP_REPEAT_REQUEST"
export const SET_CLIENT_PRODUT_LOCALE = "SET_CLIENT_PRODUT_LOCALE"
export const GET_TECHNICIAN = "GET_TECHNICIAN"
export const ZIP_CODE_ADDRESS = "ZIP_CODE_ADDRESS"
export const ZIP_CODE_ADDRESS_SUCCESS = "ZIP_CODE_ADDRESS_SUCCESS"
export const ZIP_CODE_ADDRESS_FAIL = "ZIP_CODE_ADDRESS_FAIL"
export const GET_TECHNICIAN_SUCCESS = "GET_TECHNICIAN_SUCCESS"
export const RESET_TECHNICIANS = "RESET_TECHNICIANS"
export const GET_ADDRESS_ZIPCODE = "GET_ADDRESS_ZIPCODE"
export const GET_ADDRESS_ZIPCODE_FAIL = "GET_ADDRESS_ZIPCODE_FAIL"
export const GET_ADDRESS_ZIPCODE_SUCCESS = "GET_ADDRESS_ZIPCODE_SUCCESS"
export const SET_PHONE_NUMBER = "SET_PHONE_NUMBER"
export const SET_SELECTED_RECHARGE = "SET_SELECTED_RECHARGE"
export const DELETE_SCHEDULED_RECHARGE = "DELETE_SCHEDULED_RECHARGE"
export const DELETE_SCHEDULED_RECHARGE_SUCCESS =
  "DELETE_SCHEDULED_RECHARGE_SUCCESS"
export const DELETE_SCHEDULED_RECHARGE_FAIL = "DELETE_SCHEDULED_RECHARGE_FAIL"
export const GET_QUOTATION_PRODUCTS = "GET_QUOTATION_PRODUCTS"
export const GET_QUOTATION_PRODUCTS_SUCCESS = "GET_QUOTATION_PRODUCTS_SUCCESS"
export const GET_QUOTATION_PRODUCTS_FAIL = "GET_QUOTATION_PRODUCTS_FAIL"
export const CHANGE_SCHEDULE_RECHARGES = "CHANGE_SCHEDULE_RECHARGES"
export const CHANGE_SCHEDULE_RECHARGES_SUCCESS =
  "CHANGE_SCHEDULE_RECHARGES_SUCCESS"
export const CHANGE_SCHEDULE_RECHARGES_FAIL = "CHANGE_SCHEDULE_RECHARGES_FAIL"
export const VERIFY_ADDRESS = "VERIFY_ADDRESS"
export const VERIFY_ADDRESS_SUCCESS = "VERIFY_ADDRESS_SUCCESS"
export const VERIFY_ADDRESS_FAIL = "VERIFY_ADDRESS_FAIL"
export const SET_QUOTATION_PRODUCT = "SET_QUOTATION_PRODUCT"
export const GET_CONFIG_QUOTATION_FIELDS = "GET_CONFIG_QUOTATION_FIELDS"
export const GET_CONFIG_QUOTATION_FIELDS_SUCCESS =
  "GET_CONFIG_QUOTATION_FIELDS_SUCCESS"
export const GET_CONFIG_QUOTATION_FIELDS_FAIL =
  "GET_CONFIG_QUOTATION_FIELDS_FAIL"
export const CREATE_QUOTATION = "CREATE_QUOTATION"
export const CREATE_QUOTATION_SUCCESS = "CREATE_QUOTATION_SUCCESS"
export const CREATE_QUOTATION_FAIL = "CREATE_QUOTATION_FAIL"
export const GET_QUOTATIONS_BY_PARAMS = "GET_QUOTATIONS_BY_PARAMS"
export const GET_QUOTATIONS_BY_PARAMS_FAIL = "GET_QUOTATIONS_BY_PARAMS_FAIL"
export const GET_QUOTATIONS_BY_PARAMS_SUCCESS =
  "GET_QUOTATIONS_BY_PARAMS_SUCCESS"
export const SEND_QUOTATIONS_BY_EMAIL = "SEND_QUOTATIONS_BY_EMAIL"
export const SEND_QUOTATIONS_BY_EMAIL_FAIL = "SEND_QUOTATIONS_BY_EMAIL_FAIL"
export const SEND_QUOTATIONS_BY_EMAIL_SUCCESS =
  "SEND_QUOTATIONS_BY_EMAIL_SUCCESS"
export const DOWNLOAD_QUOTATIONS = "DOWNLOAD_QUOTATIONS"
export const DOWNLOAD_QUOTATIONS_FAIL = "DOWNLOAD_QUOTATIONS_FAIL"
export const DOWNLOAD_QUOTATIONS_LOADER = "DOWNLOAD_QUOTATIONS_LOADER"
export const DOWNLOAD_QUOTATIONS_SUCCESS = "DOWNLOAD_QUOTATIONS_SUCCESS"
export const UPDATE_RECEIVING_PROTOCOL = "UPDATE_RECEIVING_PROTOCOL"
export const UPDATE_RECEIVING_PROTOCOL_SUCCESS =
  "UPDATE_RECEIVING_PROTOCOL_SUCCESS"
export const UPDATE_RECEIVING_PROTOCOL_FAIL = "UPDATE_RECEIVING_PROTOCOL_FAIL"
export const RESET_ERROR_EDIT_CUSTOMER = "RESET_ERROR_EDIT_CUSTOMER"
export const SEND_USAGES_BY_REPORT_TYPE = "SEND_USAGES_BY_REPORT_TYPE"
export const SEND_USAGES_BY_REPORT_TYPE_SUCCESS =
  "SEND_USAGES_BY_REPORT_TYPE_SUCCESS"
export const SEND_USAGES_BY_REPORT_TYPE_FAIL = "SEND_USAGES_BY_REPORT_TYPE_FAIL"
export const GET_FREE_CALLS = "GET_FREE_CALLS"
export const GET_FREE_CALLS_SUCCESS = "GET_FREE_CALLS_SUCCESS"
export const GET_FREE_CALLS_FAIL = "GET_FREE_CALLS_FAIL"
export const FILTER_FREE_CALLS = "FILTER_FREE_CALLS"
export const DOWNLOAD_FREE_CALLS_DETAILS = "DOWNLOAD_FREE_CALLS_DETAILS"
export const DOWNLOAD_FREE_CALLS_DETAILS_SUCCESS =
  "DOWNLOAD_FREE_CALLS_DETAILS_SUCCESS"
export const DOWNLOAD_FREE_CALLS_DETAILS_FAIL =
  "DOWNLOAD_FREE_CALLS_DETAILS_FAIL"
export const SEND_FREE_CALLS_EMAIL = "SEND_FREE_CALLS_EMAIL"
export const SEND_FREE_CALLS_EMAIL_SUCCESS = "SEND_FREE_CALLS_EMAIL_SUCCESS"
export const SEND_FREE_CALLS_EMAIL_FAIL = "SEND_FREE_CALLS_EMAIL_FAIL"
export const GET_DOCUMENTS = "GET_DOCUMENTS"
export const GET_DOCUMENTS_SUCCESS = "GET_DOCUMENTS_SUCCESS"
export const GET_DOCUMENTS_FAIL = "GET_DOCUMENTS_FAIL"
export const SEND_DOCUMENTS_EMAIL = "SEND_DOCUMENTS_EMAIL"
export const SEND_DOCUMENTS_EMAIL_SUCCESS = "SEND_DOCUMENTS_EMAIL_SUCCESS"
export const SEND_DOCUMENTS_EMAIL_FAIL = "SEND_DOCUMENTS_EMAIL_FAIL"
export const DOWNLOAD_DOCUMENTS = "DOWNLOAD_DOCUMENTS"
export const DOWNLOAD_DOCUMENTS_SUCCESS = "DOWNLOAD_DOCUMENTS_SUCCESS"
export const DOWNLOAD_DOCUMENTS_FAIL = "DOWNLOAD_DOCUMENTS_FAIL"
export const GET_ORDER_TRACKING = "GET_ORDER_TRACKING"
export const GET_ORDER_TRACKING_SUCCESS = "GET_ORDER_TRACKING_SUCCESS"
export const GET_ORDER_TRACKING_FAIL = "GET_ORDER_TRACKING_FAIL"
export const CANCEL_ORDER = "CANCEL_ORDER"
export const CANCEL_ORDER_SUCCESS = "CANCEL_ORDER_SUCCESS"
export const CANCEL_ORDER_FAIL = "CANCEL_ORDER_FAIL"
export const DOWNLOAD_HUGE_INVOICE = "DOWNLOAD_HUGE_INVOICE"
export const DOWNLOAD_HUGE_INVOICE_SUCCESS = "DOWNLOAD_HUGE_INVOICE_SUCCESS"
export const DOWNLOAD_HUGE_INVOICE_FAIL = "DOWNLOAD_HUGE_INVOICE_FAIL"
export const CLEAR_FEBRABAN = "CLEAR_FEBRABAN"
// action type get usage profile
export const GET_USAGE_PROFILE = "GET_USAGE_PROFILE"
export const GET_USAGE_PROFILE_SUCCESS = "GET_USAGE_PROFILE_SUCCESS"
export const GET_USAGE_PROFILE_FAIL = "GET_USAGE_PROFILE_FAIL"
export const GET_USAGE_PROFILE_CONSOLIDATED = "GET_USAGE_PROFILE_CONSOLIDATED"
export const SEND_USAGE_PROFILE_FILES = "SEND_USAGE_PROFILE_FILES"
export const SEND_USAGE_PROFILE_FILES_SUCCESS =
  "SEND_USAGE_PROFILE_FILES_SUCCESS"
export const SEND_USAGE_PROFILE_FILES_FAIL = "SEND_USAGE_PROFILE_FILES_FAIL"
export const DOWNLOAD_USAGE_PROFILE_FILES = "DOWNLOAD_USAGE_PROFILE_FILES"
export const DOWNLOAD_USAGE_PROFILE_FILES_SUCCESS =
  "DOWNLOAD_USAGE_PROFILE_FILES_SUCCESS"
export const DOWNLOAD_USAGE_PROFILE_FILES_FAIL =
  "DOWNLOAD_USAGE_PROFILE_FILES_FAIL"
export const GET_SUBSCRIPTION = "GET_SUBSCRIPTION"
export const GET_SUBSCRIPTION_SUCCESS = "GET_SUBSCRIPTION_SUCCESS"
export const GET_SUBSCRIPTION_FAIL = "GET_SUBSCRIPTION_FAIL"
export const CANCEL_SUBSCRIPTION = "CANCEL_SUBSCRIPTION"
export const CANCEL_SUBSCRIPTION_SUCCESS = "CANCEL_SUBSCRIPTION_SUCCESS"
export const CANCEL_SUBSCRIPTION_FAIL = "CANCEL_SUBSCRIPTION_FAIL"
export const PLANT_UPDATED_SUCCESS = "PLANT_UPDATED_SUCCESS"

export const DOWNLOAD_DEMANDS_FILES = "DOWNLOAD_DEMANDS_FILES"
export const DOWNLOAD_DEMANDS_FILES_SUCCESS = "DOWNLOAD_DEMANDS_FILES_SUCCESS"
export const DOWNLOAD_DEMANDS_FILES_FAIL = "DOWNLOAD_DEMANDS_FILES_FAIL"

export const OPERATION_HISTORY_EXPERIENCE = "OPERATION_HISTORY_EXPERIENCE"
export const OPERATION_HISTORY_EXPERIENCE_SUCCESS =
  "OPERATION_HISTORY_EXPERIENCE_SUCCESS"
export const OPERATION_HISTORY_EXPERIENCE_FAIL =
  "OPERATION_HISTORY_EXPERIENCE_FAIL"

export const SENSEDIA_ACCESS_TOKEN = "SENSEDIA_ACCESS_TOKEN"
export const SENSEDIA_CORP_ACCESS_TOKEN = "SENSEDIA_CORP_ACCESS_TOKEN"

export const FIND_EMAIL_BILLING_ACCOUNT = "FIND_EMAIL_BILLING_ACCOUNT"
export const FIND_EMAIL_BILLING_ACCOUNT_SUCCESS =
  "FIND_EMAIL_BILLING_ACCOUNT_SUCCESS"
export const FIND_EMAIL_BILLING_ACCOUNT_FAIL = "FIND_EMAIL_BILLING_ACCOUNT_FAIL"

export const DEACTIVATE_DIGITAL_ACCOUNT = "DEACTIVATE_DIGITAL_ACCOUNT"
export const DEACTIVATE_DIGITAL_ACCOUNT_SUCCESS =
  "DEACTIVATE_DIGITAL_ACCOUNT_SUCCESS"
export const DEACTIVATE_DIGITAL_ACCOUNT_FAIL = "DEACTIVATE_DIGITAL_ACCOUNT_FAIL"

export const GET_CUSTOMER_AWS = "GET_CUSTOMER_AWS"
export const GET_CUSTOMER_AWS_SUCCESS = "GET_CUSTOMER_AWS_SUCCESS"
export const GET_CUSTOMER_AWS_FAIL = "GET_CUSTOMER_AWS_FAIL"

export const DISABLE_ALIAS_TUTORIAL = "DISABLE_ALIAS_TUTORIAL"
export const DISABLE_ALIAS_TUTORIAL_SUCCESS = "DISABLE_ALIAS_TUTORIAL_SUCCESS"
export const DISABLE_ALIAS_TUTORIAL_FAIL = "DISABLE_ALIAS_TUTORIAL_FAIL"

export const GET_SVAS = "GET_SVAS"
export const GET_SVAS_FAIL = "GET_SVAS_FAIL"
export const GET_SVAS_SUCCESS = "GET_SVAS_SUCCESS"
export const VALIDATE_BEEGOL_ACCESS_AVAILABILITY =
  "VALIDATE_BEEGOL_ACCESS_AVAILABILITY"
export const VALIDATE_BEEGOL_ACCESS_AVAILABILITY_FAIL =
  "VALIDATE_BEEGOL_ACCESS_AVAILABILITY_FAIL"
export const VALIDATE_BEEGOL_ACCESS_AVAILABILITY_SUCCESS =
  "VALIDATE_BEEGOL_ACCESS_AVAILABILITY_SUCCESS"

export const GET_SERVICE_REQUESTS = "GET_SERVICE_REQUESTS"
export const GET_SERVICE_REQUESTS_FAIL = "GET_SERVICE_REQUESTS_FAIL"
export const GET_SERVICE_REQUESTS_SUCCESS = "GET_SERVICE_REQUESTS_SUCCESS"

export const GET_REMAINING_HOURS = "GET_REMAINING_HOURS"
export const GET_REMAINING_HOURS_FAIL = "GET_REMAINING_HOURS_FAIL"
export const GET_REMAINING_HOURS_SUCCESS = "GET_REMAINING_HOURS_SUCCESS"

export const SAVE_SERVICE_REQUEST = "SAVE_SERVICE_REQUEST"
export const SAVE_SERVICE_REQUEST_FAIL = "SAVE_SERVICE_REQUEST_FAIL"
export const SAVE_SERVICE_REQUEST_SUCCESS = "SAVE_SERVICE_REQUEST_SUCCESS"

export const FIND_ALL_ASSETS = "FIND_ALL_ASSETS"
export const FIND_ALL_ASSETS_FAIL = "FIND_ALL_ASSETS_FAIL"
export const FIND_ALL_ASSETS_SUCCESS = "FIND_ALL_ASSETS_SUCCESS"

export const GENERATE_TOKEN = "GENERATE_TOKEN"
export const GENERATE_TOKEN_FAIL = "GENERATE_TOKEN_FAIL"
export const GENERATE_TOKEN_SUCCESS = "GENERATE_TOKEN_SUCCESS"

export const AUTH_TOKEN = "AUTH_TOKEN"
export const AUTH_TOKEN_FAIL = "AUTH_TOKEN_FAIL"
export const AUTH_TOKEN_SUCCESS = "AUTH_TOKEN_SUCCESS"

export const FIND_CUSTOMER_TICKETS = "FIND_CUSTOMER_TICKETS"
export const FIND_CUSTOMER_TICKETS_FAIL = "FIND_CUSTOMER_TICKETS_FAIL"
export const FIND_CUSTOMER_TICKETS_SUCCESS = "FIND_CUSTOMER_TICKETS_SUCCESS"

export const GENERATE_SVA_TOKEN = "GENERATE_SVA_TOKEN"
export const GENERATE_SVA_TOKEN_FAIL = "GENERATE_SVA_TOKEN_FAIL"
export const GENERATE_SVA_TOKEN_SUCCESS = "GENERATE_SVA_TOKEN_SUCCESS"
export const DOWNLOAD_INVOICE_LARGE = "DOWNLOAD_INVOICE_LARGE"
export const DOWNLOAD_INVOICE_LARGE_SUCCESS = "DOWNLOAD_INVOICE_LARGE_SUCCESS"
export const DOWNLOAD_INVOICE_LARGE_FAIL = "DOWNLOAD_INVOICE_LARGE_FAIL"

export const FIND_CUSTOMER_OPEN_INVOICES = "FIND_CUSTOMER_OPEN_INVOICES"
export const FIND_CUSTOMER_OPEN_INVOICES_SUCCESS =
  "FIND_CUSTOMER_OPEN_INVOICES_SUCCESS"
export const FIND_CUSTOMER_OPEN_INVOICES_FAIL =
  "FIND_CUSTOMER_OPEN_INVOICES_FAIL"

export const FILTER_INVOICES = "FILTER_INVOICES"
export const FILTER_INVOICES_FAIL = "FILTER_INVOICES_FAIL"
export const FILTER_INVOICES_SUCCESS = "FILTER_INVOICES_SUCCESS"

export const GET_PRODUCT_FIXED_VOICE = "GET_PRODUCT_FIXED_VOICE"
export const GET_LOCATION_BY_POSTCODE = "GET_LOCATION_BY_POSTCODE"
export const VALIDATE_ADDRESS = "VALIDATE_ADDRESS"
export const GET_RANGE_FIXA = "GET_RANGE_FIXA"
export const NEW_SALES_ORDER = "NEW_SALES_ORDER"
export const NEW_SALES = "NEW_SALES"
export const SAVE_ORDER = "SAVE_ORDER"
export const GET_DASHBOARD_COUNT_STATUS = "GET_DASHBOARD_COUNT_STATUS"
export const GET_DASHBOARD_COUNT_STATUS_SUCCESS =
  "GET_DASHBOARD_COUNT_STATUS_SUCCESS"
export const GET_DASHBOARD_COUNT_STATUS_FAIL = "GET_DASHBOARD_COUNT_STATUS_FAIL"
export const GET_DASHBOARD_NUMBERS_OR_CLIENTS =
  "GET_DASHBOARD_NUMBERS_OR_CLIENTS"
export const GET_DASHBOARD_NUMBERS_OR_CLIENTS_SUCCESS =
  "GET_DASHBOARD_NUMBERS_OR_CLIENTS_SUCCESS"
export const GET_DASHBOARD_NUMBERS_OR_CLIENTS_FAIL =
  "GET_DASHBOARD_NUMBERS_OR_CLIENTS_FAIL"
export const GET_DASHBOARD_COUNT_STATUS_DETAIL =
  "GET_DASHBOARD_COUNT_STATUS_DETAIL"
export const GET_DASHBOARD_COUNT_STATUS_DETAIL_SUCCESS =
  "GET_DASHBOARD_COUNT_STATUS_DETAIL_SUCCESS"
export const GET_DASHBOARD_COUNT_STATUS_DETAIL_FAIL =
  "GET_DASHBOARD_COUNT_STATUS_DETAIL_FAIL"
export const GET_DASHBOARD_NUMBERS_DETAIL = "GET_DASHBOARD_NUMBERS_DETAIL"
export const GET_DASHBOARD_NUMBERS_DETAIL_SUCCESS =
  "GET_DASHBOARD_NUMBERS_DETAIL_SUCCESS"
export const GET_DASHBOARD_NUMBERS_DETAIL_FAIL =
  "GET_DASHBOARD_NUMBERS_DETAIL_FAIL"
export const GET_CUSTOMER_DETAILS = "GET_CUSTOMER_DETAILS"

export const SAVE_NEW_SALE_PORTABILITY = "SAVE_NEW_SALE_PORTABILITY"
export const SAVE_NEW_SALE_PORTABILITY_SUCCESS =
  "SAVE_NEW_SALE_PORTABILITY_SUCCESS"
export const SAVE_NEW_SALE_PORTABILITY_FAIL = "SAVE_NEW_SALE_PORTABILITY_FAIL"
export const SPECIALIST_ANALYSIS = "SPECIALIST_ANALYSIS"
export const SPECIALIST_ANALYSIS_SUCCESS = "SPECIALIST_ANALYSIS_SUCCESS"
export const SPECIALIST_ANALYSIS_FAIL = "SPECIALIST_ANALYSIS_FAIL"
export const GET_SPECIALIST_REQUESTS = "GET_SPECIALIST_REQUESTS"
export const GET_SPECIALIST_REQUESTS_FAIL = "GET_SPECIALIST_REQUESTS_FAIL"
export const GET_SPECIALIST_REQUESTS_SUCCESS = "GET_SPECIALIST_REQUESTS_SUCCESS"
export const GET_VALID_LOCALITIES = "GET_VALID_LOCALITIES"
export const GET_VALID_LOCALITIES_SUCCESS = "GET_VALID_LOCALITIES_SUCCESS"
export const GET_VALID_LOCALITIES_FAIL = "GET_VALID_LOCALITIES_FAIL"
export const GET_VALID_CIRCUITS = "GET_VALID_CIRCUITS"
export const SAVE_DASHBOARD_DOCUMENT = "SAVE_DASHBOARD_DOCUMENT"
export const GET_ACTIONS_NUMBERS_OR_CLIENTS = "GET_ACTIONS_NUMBERS_OR_CLIENTS"
export const GET_ACTIONS_NUMBERS_OR_CLIENTS_SUCCESS =
  "GET_ACTIONS_NUMBERS_OR_CLIENTS_SUCCESS"
export const GET_ACTIONS_NUMBERS_OR_CLIENTS_FAIL =
  "GET_ACTIONS_NUMBERS_OR_CLIENTS_FAIL"
export const SAVE_ACTIONS_EDIT_CLIENT = "SAVE_ACTIONS_EDIT_CLIENT"
export const GET_RESCHEDULE_DATES = "GET_RESCHEDULE_DATES"
export const GET_RESCHEDULE_DATES_FAIL = "GET_RESCHEDULE_DATES_FAIL"
export const GET_RESCHEDULE_DATES_SUCCESS = "GET_RESCHEDULE_DATES_SUCCESS"
export const SAVE_RESCHEDULE_SUSPEND = "SAVE_RESCHEDULE_SUSPEND"
export const GET_ACTIONS_EXPORT_CSV = "GET_ACTIONS_EXPORT_CSV"

export const SEND_DOCUMENTS_BY_EMAIL = "SEND_DOCUMENTS_BY_EMAIL"
export const SEND_DOCUMENTS_BY_EMAIL_SUCCESS = "SEND_DOCUMENTS_BY_EMAIL_SUCCESS"
export const SEND_DOCUMENTS_BY_EMAIL_FAIL = "SEND_DOCUMENTS_BY_EMAIL_FAIL"

export const BLANK_TYPE = "BLANK_TYPE"

export const GET_INVOICE_BARCODE = "GET_INVOICE_BARCODE"
export const GET_INVOICE_BARCODE_SUCCESS = "GET_INVOICE_BARCODE_SUCCESS"
export const GET_INVOICE_BARCODE_ERROR = "GET_INVOICE_BARCODE_ERROR"

export const SIGN_IN_SUBSIDIARY = "SIGN_IN_SUBSIDIARY"
export const SIGN_IN_SUBSIDIARY_SUCCESS = "SIGN_IN_SUBSIDIARY_SUCCESS"
export const SIGN_IN_SUBSIDIARY_FAIL = "SIGN_IN_SUBSIDIARY_FAIL"

export const GET_INTEREST_FINES = "GET_INTEREST_FINES"
export const GET_INTEREST_FINES_SUCCESS = "GET_INTEREST_FINES_SUCCESS"
export const GET_INTEREST_FINES_FAIL = "GET_INTEREST_FINES_FAIL"

export const GET_READJUSTMENT_IGP = "GET_READJUSTMENT_IGP"
export const GET_READJUSTMENT_IGP_SUCCESS = "GET_READJUSTMENT_IGP_SUCCESS"
export const GET_READJUSTMENT_IGP_FAIL = "GET_READJUSTMENT_IGP_FAIL"

export const GET_READJUSTMENT_ANATEL = "GET_READJUSTMENT_ANATEL"
export const GET_READJUSTMENT_ANATEL_SUCCESS = "GET_READJUSTMENT_ANATEL_SUCCESS"
export const GET_READJUSTMENT_ANATEL_FAIL = "GET_READJUSTMENT_ANATEL_FAIL"

export const GET_CANCELLATION_VALUE = "GET_CANCELLATION_VALUE"
export const GET_CANCELLATION_VALUE_SUCCESS = "GET_CANCELLATION_VALUE_SUCCESS"
export const GET_CANCELLATION_VALUE_FAIL = "GET_CANCELLATION_VALUE_FAIL"

export const GET_INVOICE_VALUE = "GET_INVOICE_VALUE"
export const GET_INVOICE_VALUE_SUCCESS = "GET_INVOICE_VALUE_SUCCESS"
export const GET_INVOICE_VALUE_FAIL = "GET_INVOICE_VALUE_FAIL"

export const GET_NRC_VALUE = "GET_NRC_VALUE"
export const GET_NRC_VALUE_SUCCESS = "GET_NRC_VALUE_SUCCESS"
export const GET_NRC_VALUE_FAIL = "GET_NRC_VALUE_FAIL"

export const GET_ADJUSTMENT = "GET_ADJUSTMENT"
export const GET_ADJUSTMENT_SUCCESS = "GET_ADJUSTMENT_SUCCESS"
export const GET_ADJUSTMENT_FAIL = "GET_ADJUSTMENT_FAIL"

export const SAVE_INVOICE_DISPUTING = "SAVE_INVOICE_DISPUTING"
export const SAVE_INVOICE_DISPUTING_SUCCESS = "SAVE_INVOICE_DISPUTING_SUCCESS"
export const SAVE_INVOICE_DISPUTING_FAIL = "SAVE_INVOICE_DISPUTING_FAIL"

export const SEND_INVOICE_DISPUTING_FILE = "SEND_INVOICE_DISPUTING_FILE"
export const SEND_INVOICE_DISPUTING_FILE_SUCCESS =
  "SEND_INVOICE_DISPUTING_FILE_SUCCESS"
export const SEND_INVOICE_DISPUTING_FILE_FAIL =
  "SEND_INVOICE_DISPUTING_FILE_FAIL"

export const GET_INVOICE_DISPUTING_INFORMATION =
  "GET_INVOICE_DISPUTING_INFORMATION"
export const GET_INVOICE_DISPUTING_INFORMATION_SUCCESS =
  "GET_INVOICE_DISPUTING_INFORMATION_SUCCESS"
export const GET_INVOICE_DISPUTING_INFORMATION_FAIL =
  "GET_INVOICE_DISPUTING_INFORMATION_FAIL"
export const GET_BLOCKED_PRODUCT = "GET_BLOCKED_PRODUCT"

export const GET_BLOCKED_PRODUCTS = "GET_BLOCKED_PRODUCTS"
export const GET_BLOCKED_PRODUCTS_SUCCESS = "GET_BLOCKED_PRODUCTS_SUCCESS"

export const GET_ALL_PRODUCTS = "GET_ALL_PRODUCTS"
export const GET_ALL_PRODUCTS_SUCCESS = "GET_ALL_PRODUCTS_SUCCESS"
export const GET_ALL_PRODUCTS_FAIL = "GET_ALL_PRODUCTS_FAIL"

export const GET_ASSET_DETAILS = "GET_ASSET_DETAILS"
export const GET_ASSET_DETAILS_SUCCESS = "GET_ASSET_DETAILS_SUCCESS"
export const GET_ASSET_DETAILS_FAIL = "GET_ASSET_DETAILS_FAIL"

export const GET_INVENTARIO_DIGITAL = "GET_INVENTARIO_DIGITAL"
export const GET_INVENTARIO_DIGITAL_SUCCESS = "GET_INVENTARIO_DIGITAL_SUCCESS"
export const GET_INVENTARIO_DIGITAL_FAIL = "GET_INVENTARIO_DIGITAL_FAIL"

export const OPEN_TICKET = "OPEN_TICKET"
export const OPEN_TICKET_SUCCESS = "OPEN_TICKET_SUCCESS"
export const OPEN_TICKET_FAIL = "OPEN_TICKET_FAIL"

export const GET_INVENTARIO_DIGITAL_HOSTNAME = "GET_INVENTARIO_DIGITAL_HOSTNAME"
export const GET_INVENTARIO_DIGITAL_HOSTNAME_SUCCESS =
  "GET_INVENTARIO_DIGITAL_HOSTNAME_SUCCESS"
export const GET_INVENTARIO_DIGITAL_HOSTNAME_FAIL =
  "GET_INVENTARIO_DIGITAL_HOSTNAME_FAIL"

export const GET_CALLS = "GET_CALLS"
export const GET_CALLS_SUCCESS = "GET_CALLS_SUCCESS"
export const GET_CALLS_FAIL = "GET_CALLS_FAIL"

export const SERVICE_TNCM2 = "SERVICE_TNCM2"
export const SERVICE_TNCM2_SUCCESS = "SERVICE_TNCM2_SUCCESS"
export const SERVICE_TNCM2_FAIL = "SERVICE_TNCM2_FAIL"

export const SERVICE_TNCM3 = "SERVICE_TNCM3"
export const SERVICE_TNCM3_SUCCESS = "SERVICE_TNCM3_SUCCESS"
export const SERVICE_TNCM3_FAIL = "SERVICE_TNCM3_FAIL"

export const GET_PROTOCOL = "GET_PROTOCOL"
export const GET_PROTOCOL_SUCCESS = "GET_PROTOCOL_SUCCESS"
export const GET_PROTOCOL_FAIL = "GET_PROTOCOL_FAIL"

export const CREATE_INTERACTION = "CREATE_INTERACTION"
export const GET_INTERACTION = "GET_INTERACTION"
export const GET_INTERACTION_SUCCESS = "GET_INTERACTION_SUCCESS"
export const GET_INTERACTION_FAIL = "GET_INTERACTION_FAIL"

export const ADD_COMMENTS = "ADD_COMMENTS"
export const ADD_COMMENTS_SUCCESS = "ADD_COMMENTS_SUCCESS"
export const ADD_COMMENTS_FAIL = "ADD_COMMENTS_FAIL"

export const SERVICE_TNCM4 = "SERVICE_TNCM4"
export const SERVICE_TNCM4_SUCCESS = "SERVICE_TNCM4_SUCCESS"
export const SERVICE_TNCM4_FAIL = "SERVICE_TNCM4_FAIL"

export const SEND_MAIL_MY_CALLS = "SEND_MAIL_MY_CALLS"
export const SEND_MAIL_MY_CALLS_FAIL = "SEND_MAIL_MY_CALLS_FAIL"
export const SEND_MAIL_MY_CALLS_SUCCESS = "SEND_MAIL_MY_CALLS_SUCCESS"

export const CLOSE_ORDER = "CLOSE_ORDER"
export const CLOSE_ORDER_FAIL = "CLOSE_ORDER_FAIL"
export const CLOSE_ORDER_SUCCESS = "CLOSE_ORDER_SUCCESS"

export const LAST_ORDERS = "LAST_ORDERS"
export const LAST_ORDERS_SUCCESS = "LAST_ORDERS_SUCCESS"
export const LAST_ORDERS_FAIL = "LAST_ORDERS_FAIL"

export const GET_RECHARGE_HASH = "GET_RECHARGE_HASH"
export const GET_RECHARGE_VALUES = "GET_RECHARGE_VALUES"
export const GET_RECHARGE_HISTORY = "GET_RECHARGE_HISTORY"
export const SEND_NEW_CARD = "SEND_NEW_CARD"
export const GET_RECHARGE_CARDS = "GET_RECHARGE_CARDS"
export const DELETE_CARD = "DELETE_CARD"
export const RECHARGE_LOGIN = "RECHARGE_LOGIN"
export const CREATE_RECHARGE = "CREATE_RECHARGE"
export const GET_RECHARGE_HISTORY_BY_DOCUMENT =
  "GET_RECHARGE_HISTORY_BY_DOCUMENT"
export const DOWNLOAD_AUDIO = "DOWNLOAD_AUDIO"

export const AUTHENTICATE = "AUTHENTICATE"
export const AUTHENTICATE_SUCCESS = "AUTHENTICATE_SUCCESS"
export const AUTHENTICATE_ERROR = "AUTHENTICATE_ERROR"

export const ATTACHMENT = "ATTACHMENT"
export const ATTACHMENT_SUCCESS = "ATTACHMENT_SUCCESS"
export const ATTACHMENT_FAIL = "ATTACHMENT_FAIL"
export const ATTACHMENT_PROGRESS = "ATTACHMENT_PROGRESS"

export const VERIFY_CIRCUIT = "VERIFY_CIRCUIT"
export const VERIFY_CIRCUIT_SUCCESS = "VERIFY_CIRCUIT_SUCCESS"
export const VERIFY_CIRCUIT_FAIL = "VERIFY_CIRCUIT_FAIL"

export const UNBLOCKING_CIRCUIT = "UNBLOCKING_CIRCUIT"
export const UNBLOCKING_CIRCUIT_SUCCESS = "UNBLOCKING_CIRCUIT_SUCCESS"
export const UNBLOCKING_CIRCUIT_FAIL = "UNBLOCKING_CIRCUIT_FAIL"

export const VERIFY_MASSIVE = "VERIFY_MASSIVE"
export const VERIFY_MASSIVE_SUCCESS = "VERIFY_MASSIVE_SUCCESS"
export const VERIFY_MASSIVE_FAIL = "VERIFY_MASSIVE_FAIL"

export const VERIFY_CALLED = "VERIFY_CALLED"
export const VERIFY_CALLED_SUCCESS = "VERIFY_CALLED_SUCCESS"
export const VERIFY_CALLED_FAIL = "VERIFY_CALLED_FAIL"

export const GET_DETAIL_PROTOCOL = "GET_DETAIL_PROTOCOL"
export const GET_DETAIL_PROTOCOL_SUCCESS = "GET_DETAIL_PROTOCOL_SUCCESS"
export const GET_DETAIL_PROTOCOL_FAIL = "GET_DETAIL_PROTOCOL_FAIL"

export const ALGAR_INITIAL_TEST = "ALGAR_INITIAL_TEST"
export const ALGAR_INITIAL_TEST_SUCCESS = "ALGAR_INITIAL_TEST_SUCCESS"
export const ALGAR_INITIAL_TEST_FAIL = "ALGAR_INITIAL_TEST_FAIL"

export const GET_ALGAR_VERIFY_TEST = "GET_ALGAR_VERIFY_TEST"
export const GET_ALGAR_VERIFY_TEST_SUCCESS = "GET_ALGAR_VERIFY_TEST_SUCCESS"
export const GET_ALGAR_VERIFY_TEST_FAIL = "GET_ALGAR_VERIFY_TEST_FAIL"

export const PRE_SCHEDULE_WINDOWS = "PRE_SCHEDULE_WINDOWS"
export const PRE_SCHEDULE_WINDOWS_SUCCESS = "PRE_SCHEDULE_WINDOWS_SUCCESS"
export const PRE_SCHEDULE_WINDOWS_FAIL = "PRE_SCHEDULE_WINDOWS_FAIL"

export const PRE_SCHEDULE = "PRE_SCHEDULE"
export const PRE_SCHEDULE_SUCCESS = "PRE_SCHEDULE_SUCCESS"
export const PRE_SCHEDULE_FAIL = "PRE_SCHEDULE_FAIL"

export const CREATE_LEAD = "CREATE_LEAD"
export const CREATE_LEAD_SUCCESS = "CREATE_LEAD_SUCCESS"
export const CREATE_LEAD_FAIL = "CREATE_LEAD_FAIL"

export const AUTHENTICATION_PROCESSING_START = "AUTHENTICATION_LOADING_START"
export const AUTHENTICATION_PROCESSING_END = "AUTHENTICATION_LOADING_END"

export const CREATE_MULTI_USER = "CREATE_MULTI_USER"
export const DISABLE_MULTI_USER = "DISABLE_MULTI_USER"
export const ACTIVE_MULTI_USER = "ACTIVE_MULTI_USER"

export const GET_COMPLEMENT_TYPES = "GET_COMPLEMENT_TYPES"
export const VALIDATE_INSTALLATION_ADDRESS = "VALIDATE_INSTALLATION_ADDRESS"
export const CALCULATE_CHANGE_TAX_ADDRESS = "CALCULATE_CHANGE_TAX_ADDRESS"
export const SAVE_NEW_INSTALLATION_ADDRESS = "SAVE_NEW_INSTALLATION_ADDRESS"
export const VALIDATE_AND_QUERY_ADDRESS = "VALIDATE_AND_QUERY_ADDRESS"
export const GENERATE_PROTOCOL_INSTALLATION_ADDRESS =
  "GENERATE_PROTOCOL_INSTALLATION_ADDRESS"

export const GET_NBO_OFFERS = "GET_NBO_OFFERS"
export const GET_NBO_OFFERS_SUCCESS = "GET_NBO_OFFERS_SUCCESS"
export const GET_NBO_OFFERS_FAIL = "GET_NBO_OFFERS_FAIL"

export const GET_ALL_CONTRACTS_PRODUCT = "GET_ALL_CONTRACTS_PRODUCT"
export const GET_ALL_CONTRACTS_PRODUCT_SUCCESS =
  "GET_ALL_CONTRACTS_PRODUCT_SUCCESS"
export const GET_ALL_CONTRACTS_PRODUCT_FAIL = "GET_ALL_CONTRACTS_PRODUCT_FAIL"

export const GET_ALL_CONTRACTS_GED_PRODUCT = "GET_ALL_CONTRACTS_GED_PRODUCT"
export const GET_ALL_CONTRACTS_GED_PRODUCT_SUCCESS =
  "GET_ALL_CONTRACTS_GED_PRODUCT_SUCCESS"
export const GET_ALL_CONTRACTS_GED_PRODUCT_FAIL =
  "GET_ALL_CONTRACTS_GED_PRODUCT_FAIL"

export const GET_FILE_CONTRACT = "GET_FILE_CONTRACT"
export const GET_FILE_CONTRACT_SUCCESS = "GET_FILE_CONTRACT_SUCCESS"
export const GET_FILE_CONTRACT_FAIL = "GET_FILE_CONTRACT_FAIL"

export const DOWNLOAD_CONTRACT = "DOWNLOAD_CONTRACT"
export const DOWNLOAD_CONTRACT_SUCCESS = "DOWNLOAD_CONTRACT_SUCCESS"
export const DOWNLOAD_CONTRACT_FAIL = "DOWNLOAD_CONTRACT_FAIL"

export const SEND_MAIL_CONTRACT = "SEND_MAIL_CONTRACT"
export const SEND_MAIL_CONTRACT_SUCCESS = "SEND_MAIL_CONTRACT_SUCCESS"
export const SEND_MAIL_CONTRACT_FAIL = "SEND_MAIL_CONTRACT_FAIL"

export const GET_SALES_ORDER = "GET_SALES_ORDER"
export const GET_SALES_ORDER_SUCCESS = "GET_SALES_ORDER_SUCCESS"
export const GET_SALES_ORDER_ERROR = "GET_SALES_ORDER_ERROR"

export const DOWNLOAD_SALES_ORDER_TERM = "DOWNLOAD_SALES_ORDER_TERM"
export const DOWNLOAD_SALES_ORDER_TERM_SUCCESS =
  "DOWNLOAD_SALES_ORDER_TERM_SUCCESS"
export const DOWNLOAD_SALES_ORDER_TERM_ERROR = "DOWNLOAD_SALES_ORDER_TERM_ERROR"

export const ACCEPT_SALES_ORDER_TERM = "ACCEPT_SALES_ORDER_TERM"
export const ACCEPT_SALES_ORDER_TERM_SUCCESS = "ACCEPT_SALES_ORDER_TERM_SUCCESS"
export const ACCEPT_SALES_ORDER_TERM_ERROR = "ACCEPT_SALES_ORDER_TERM_ERROR"
export const CHECK_ADVANCE_NOTICE = "CHECK_ADVANCE_NOTICE"
export const CHECK_ADVANCE_NOTICE_SUCCESS = "CHECK_ADVANCE_NOTICE_SUCCESS"
export const CHECK_ADVANCE_NOTICE_FAIL = "CHECK_ADVANCE_NOTICE_FAIL"

export const CHECK_CANCELLATION_FINES = "CHECK_CANCELLATION_FINES"
export const CHECK_CANCELLATION_FINES_SUCCESS =
  "CHECK_CANCELLATION_FINES_SUCCESS"
export const CHECK_CANCELLATION_FINES_FAIL = "CHECK_CANCELLATION_FINES_FAIL"

export const REQUEST_CANCELLATION = "REQUEST_CANCELLATION"
export const REQUEST_CANCELLATION_SUCCESS = "REQUEST_CANCELLATION_SUCCESS"
export const REQUEST_CANCELLATION_FAIL = "REQUEST_CANCELLATION_FAIL"

export const SEND_PRODUCT_CANCELLATION_REQUEST =
  "SEND_PRODUCT_CANCELLATION_REQUEST"

export const CREATE_PROTOCOL = "CREATE_PROTOCOL"
export const SEND_MAIL_PROTOCOL = "SEND_MAIL_PROTOCOL"

export const LIST_CONFIG_VALUES = "LIST_CONFIG_VALUES"
export const LIST_CONFIG_VALUES_SUCCESS = "LIST_CONFIG_VALUES_SUCCESS"
export const LIST_CONFIG_VALUES_FAIL = "LIST_CONFIG_VALUES_FAIL"
export const CREATE_PROTOCOL_TECHNICAL_SUPPORT =
  "CREATE_PROTOCOL_TECHNICAL_SUPPORT"

export const PRODUCT_IS_STANDARD = "PRODUCT_IS_STANDARD"
export const CHECK_VERIFY_MASSIVE = "CHECK_VERIFY_MASSIVE"
export const GET_SUPPORT_ORDER = "GET_SUPPORT_ORDER"
export const SUPPORT_LIST_MODEM = "SUPPORT_LIST_MODEM"
export const SUPPORT_RESET_MODEM = "SUPPORT_LIST_MODEM"
export const SUPPORT_TIME_SLOTS = "SUPPORT_TIME_SLOTS"
export const CREATE_SUPPORT_SCHEDULING = "CREATE_SUPPORT_SCHEDULING"
export const PROTOCOL_DETAILS = "PROTOCOL_DETAILS"
export const PROTOCOL_DETAILS_SUCCESS = "PROTOCOL_DETAILS_SUCCESS"
export const PROTOCOL_DETAILS_FAIL = "PROTOCOL_DETAILS_FAIL"

export const REQUEST_AUDIO_PROTOCOL = "REQUEST_AUDIO_PROTOCOL"
export const SERVICE_REQUESTS_CUSTOMER = "SERVICE_REQUESTS_CUSTOMER"

export const GET_PRODUCTS_SHARED_DATA = "GET_PRODUCTS_SHARED_DATA"
export const GET_PRODUCTS_SHARED_DATA_SUCCESS =
  "GET_PRODUCTS_SHARED_DATA_SUCCESS"
export const GET_PRODUCTS_SHARED_DATA_FAIL = "GET_PRODUCTS_SHARED_DATA_FAIL"
export const GET_INVOICES_SUMMARY = "GET_INVOICES_SUMMARY"
export const GET_INVOICES_HISTORIC = "GET_INVOICES_HISTORIC"

export const GET_BILLS_BY_DOCUMENT_NUMBER = "GET_BILLS_BY_DOCUMENT_NUMBER"
export const GET_BILLS_BY_DOCUMENT_NUMBER_SUCCESS =
  "GET_BILLS_BY_DOCUMENT_NUMBER_SUCCESS"
export const GET_BILLS_BY_DOCUMENT_NUMBER_ERROR =
  "GET_BILLS_BY_DOCUMENT_NUMBER_ERROR"

export const GET_PRODUCTS_INVOICE = "GET_PRODUCTS_INVOICE"
export const GET_PRODUCTS_INVOICE_SUCCESS = "GET_PRODUCTS_INVOICE_SUCCESS"
export const GET_PRODUCTS_INVOICE_ERROR = "GET_PRODUCTS_INVOICE_ERROR"

export const GET_SUBSIDIARY_DETAILS = "GET_SUBSIDIARY_DETAILS"
export const GET_SUBSIDIARY_DETAILS_SUCCESS = "GET_SUBSIDIARY_DETAILS_SUCCESS"
export const GET_SUBSIDIARY_DETAILS_ERROR = "GET_SUBSIDIARY_DETAILS_ERROR"

export const GET_PRODUCTS_SUBSIDIARY = "GET_PRODUCTS_SUBSIDIARY"
export const GET_PRODUCTS_SUBSIDIARY_SUCCESS = "GET_PRODUCTS_SUBSIDIARY_SUCCESS"
export const GET_PRODUCTS_SUBSIDIARY_ERROR = "GET_PRODUCTS_SUBSIDIARY_ERROR"
export const LIST_INVOICE_RECHARGES = "LIST_INVOICE_RECHARGES"
export const DOWNLOAD_INVOICE_RECHARGE = "DOWNLOAD_INVOICE_RECHARGE"
export const DOWNLOAD_MULTIPLE_INVOICE_RECHARGES =
  "DOWNLOAD_MULTIPLE_INVOICE_RECHARGES"

export const VALIDATE_CONGLOMERATES = "VALIDATE_CONGLOMERATES"
export const LEAD_SHARED_ENERGY = "LEAD_SHARED_ENERGY"
export const ENERGY_DISTRIBUTOR = "ENERGY_DISTRIBUTOR"

export const WORK_ORDER_SOM = "WORK_ORDER_SOM"
export const WORK_ORDER_SOM_SUCCESS = "WORK_ORDER_SOM_SUCCESS"
export const WORK_ORDER_SOM_FAIL = "WORK_ORDER_SOM_FAIL"
export const COMMENTS_SOM = "COMMENTS_SOM"
export const WORK_ORDER_CONTROL_DESK = "WORK_ORDER_CONTROL_DESK"
export const WORK_ORDER_CONTROL_DESK_SUCCESS = "WORK_ORDER_CONTROL_DESK_SUCCESS"
export const WORK_ORDER_CONTROL_DESK_FAIL = "WORK_ORDER_CONTROL_DESK_FAIL"
export const COMMENTS_CONTROL_DESK = "COMMENTS_CONTROL_DESK"
export const CREATE_WORK_ORDER = "CREATE_WORK_ORDER"
export const WORK_ORDER_SERVICE_CATEGORY = "WORK_ORDER_SERVICE_CATEGORY"
export const WORK_ORDER_TYPE_REQUEST = "WORK_ORDER_TYPE_REQUEST"
export const WORK_ORDER_TYPE_DOMAIN = "WORK_ORDER_TYPE_DOMAIN"



// WEBPACK FOOTER //
// ./src/services/state/action-types.js